class Process {
    constructor( name, tasks, initialState ) {
        this.name = name;
        this.tasks = tasks;
        this.initialState = initialState;
    }
}

class Task {

    constructor( title, detail, instructions ) {

        this.title = title;
        this.detail = detail;
        this.instructions = instructions;

    }

    completion = () => [ this.instructions.filter( inst => inst.complete ).length, this.instructions.length ];

    checkCriteria = ( activeInstruction, clicked, scene ) => {

        let needsUpdate = false;
        const task  = this.instructions[activeInstruction];

        if( task ){

            if ( task.criteria === ( clicked.name ? clicked.name : clicked.id ) ){

                task.complete = task.onComplete ? task.onComplete( scene, clicked ) : true;
                clicked.name && clicked.animation && clicked.animation( clicked, scene );

            }

            needsUpdate = task.complete;

        }

        return needsUpdate

    }

    reset = scene => {

        scene.traverse( obj => {

            if( obj.origPos ){

                obj.position.copy( obj.origPos );
                obj.quaternion.copy( obj.origQuat );
                obj.material = obj.origMat.clone();

            }

        });

        this.instructions.forEach( instruction => instruction.complete = false );

    }

}

class Instruction {

    constructor( task, criteria, onComplete ) {

        this.task = task;
        this.criteria = criteria;
        this.complete = false;
        this.onComplete = onComplete;

    }


}

export { Process, Task, Instruction }
